<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}" @failure="formFailure"
            :save-params="{api_key: currentUser.api_key}">

        <div class="row">
            <validated-input class="col-6" label="Title" v-model="model.title"
                             :rules="rules.title" :disabled="loading"/>

            <filee-input
    ref="imageInput"
    class="c-file-input col-6"
    label="Image"
    v-model="model.image"
    :disabled="loading"
    @input="validateImage($event, model)"
/>
        </div>
        <div class="row">
            <div class="col">
                <image-info :width="1521" :height="397"/>
            </div>
        </div>

        <div class="row">
            <validated-vue-select class="col-6" label="Type" type="time" v-model="model.type"
                                  :options="typeOptions"
                                  :rules="rules.type" :disabled="loading"/>

            <checkbox-input class="col-6" label="Disable" v-model="model.disabled"
                            :rules="rules.disabled" :disabled="loading"/>
        </div>
        <btn class="trn" size="sm" :loading="loading" color="primary" text="Save"
             loading-text="Saving..." :disabled="loading"/>

    </b-form>
</template>

<script>
import urls from '../../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name     : 'AddBanner',
    computed : { ...mapGetters(['currentUser']) },
    data () {
        return {
            addUrl : urls.admin.event.banner.addEdit,
            rules  : {
                title : {
                    required : true
                },
                image : {
                    required : true
                },
                type : {
                    required : true
                },
                disabled : {
                    required : false
                }
            },
            typeOptions : [
                { label : 'Home', value : 'Home' },
                { label : 'Service', value : 'Service' },
                { label : 'Training', value : 'Training' }
            ]
        };
    },

    methods : {

        validateImage (files, model) {
            if (!files || files.length === 0) {
                return;
            }

            const file = files[0];
            const image = new Image();

            image.onload = () => {
                URL.revokeObjectURL(image.src);

                if (image.width !== 1521 || image.height !== 397) {
                    this.$notify(
                        'Please upload an image with dimensions 1521 × 397 pixels.',
                        'Invalid Image',
                        {
                            type : 'warning'
                        }
                    );

                    // Clear the file input
                    this.$refs.imageInput.text = '';
                    this.$refs.imageInput.files = [];

                    // Clear the model
                    model.image = [];

                    return;
                }

                // Valid image
                model.image = files;
            };

            image.onerror = () => {
                URL.revokeObjectURL(image.src);

                this.$notify(
                    'Unable to read the selected image.',
                    'Invalid Image',
                    {
                        type : 'warning'
                    }
                );

                this.$refs.imageInput.text = '';
                this.$refs.imageInput.files = [];
                model.image = [];
            };

            image.src = URL.createObjectURL(file);
        },

        formSuccess () {
            this.$notify(
                'Successfully Added Banner..!',
                'Success',
                {
                    type : 'success'
                }
            );

            this.$emit('success');
        },

        formFailure (response) {
            const json = response.data;

            if (json.permission === false) {
                this.$notify(
                    'Invalid Authentication..!',
                    'Permission Denied',
                    {
                        type : 'warning'
                    }
                );
            }
        }
    }
};
</script>

<style scoped>

</style>
